import { FC } from 'react';

import type { TradeAllocationProps } from './TradeAllocation.connect';
import { connectTradeAllocation } from './TradeAllocation.connect';
import { TradeAllocationGrid, TradeAllocationGridSkeleton } from './TradeAllocationGrid/TradeAllocationGrid';

const Component: FC<TradeAllocationProps> = ({
  allocations,
  custodians,
  currency,
  unallocatedNotional,
  hasIndependentAmount,
  isReadOnly,
  isLoading,
  onAllocationChanged,
  onAllocationRemoved,
  preComPrice,
  offerPriceUnit,
}) => {
  if (isLoading) {
    return <TradeAllocationGridSkeleton />;
  }

  const availableCustodians = custodians?.isSuccess ? custodians.data! : [];
  return (
    <TradeAllocationGrid
      allocations={allocations}
      custodians={availableCustodians}
      onAllocationChanged={onAllocationChanged}
      onAllocationRemoved={onAllocationRemoved}
      currency={currency}
      unallocatedNotional={unallocatedNotional}
      isDisabled={isReadOnly}
      hasIndependentAmount={hasIndependentAmount}
      preComPrice={preComPrice}
      offerPriceUnit={offerPriceUnit}
    />
  );
};

Component.displayName = 'TradeAllocation';

export const TradeAllocation = connectTradeAllocation(Component);
